import * as React from "react";
import uncheck from '../../../resources/img/checkbox/checkbox_unchecked.png'
import check from '../../../resources/img/checkbox/checkbox_checked.png'

export default class PaymentListPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rc_codes: [],
            userToSearch: '',
            payments: [
                {
                    billRefNo:1,
                    payment_date:"24 April 2023 11:12:33",
                    bill_desc:"Payment for Chamwino District Land Use Plan",
                    payer_name:"Admin Tester",
                    amount:"10,000.00",
                    control_number:"99000399498585",
                    status:"Received"
                },
                {
                    billRefNo:2,
                    payment_date:"23 April 2023 14:04:59",
                    bill_desc:"Payment for Dodoma Regional Land Use Plan",
                    payer_name:"Admin Tester",
                    amount:"12,000.00",
                    control_number:"99000354332624",
                    status:"Received"
                }
            ],
            syncBtn: 'Sync All',
            current_tab: 0,
            totalPages: 1,
            next: null,
            previous: null,
            pageSize: 20
        }
        PaymentListPane.self = this
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    toggleCheck(i, userId) {
        let doc = document.getElementById('chk_' + i);
        if (doc.src === uncheck) {
            doc.src = check;

            return;
        }
        doc.src = uncheck;
    }

    componentDidMount() {
        //PaymentListPane.loadData()
    }

    render() {

        return (<div style={{
                width: '98.9%', margin: '4px', border: '1px solid #dddd', padding: '4px',
                height: '90vh', borderTop: '1px solid #efefef', overflowX: 'hidden', overflowY: 'auto'
            }}>
                {/*<div className={'col col-sm-12'} style={{
                    padding: '8px',
                    background: '#efefef',
                    border: '1px solid #ccc',
                    marginBottom: '4px',
                    width: '7.7%',
                    float: 'right'
                }}>
                    <button className={'btn submit'} style={{float: 'left'}} onClick={() => {
                        PopDetail.show('Add New Payment', <AddNewPaymentPane loadPayments={PaymentListPane.loadData}
                                                                             key={new Date().getMilliseconds()}/>, 65)
                    }}>
                        <span className={'fa fa-plus'}/>New Payment
                    </button>
                </div>*/}

                <div className={'col col-sm-12'} style={{
                    padding: '4px',
                    background: '#efefef',
                    border: '1px solid #ccc',
                    marginBottom: '4px',
                    width: '99.5%',
                    float: 'left'
                }}>
                    <div className={'row'}>

                        <div className={'col col-sm-1'}></div>
                        <div className={'search-div col col col-sm-4'}>
                            <span className={'fa fa-search'}/>
                            <input name={'search'} onChange={this.handleChange}/>
                        </div>
                        <div className={'col col-sm-1'}></div>
                        {/*<button className={'btn refresh'} >
                        Search
                    </button>*/}
                    </div>

                </div>

                <div className={'col col-sm-12'} style={{padding: '8px 0 2px 0', float: 'left'}}>
                    {/*{this.state.modules.map((d,i)=>{
                        return(<div onClick={()=>this.fetchModules(i,d)} key={i} className={this.state.current_tab===i?'tab tab-active':'tab'}>
                            <span className={'fa fa-file-o'}/>{d.name}</div>)
                    })}*/}
                </div>
                <div className={'col col-sm-12'}>
                    <table className={'tb'} style={{width: '100%'}}>
                        <thead>
                        <tr>
                            <th style={{textAlign: 'center', backgroundColor: 'white'}}>
                                No.
                            </th>
                            <th>Payment Date</th>
                            <th style={{position: 'sticky', left: 0, zIndex: 2}}>Bill Description</th>
                            <th>Payer Name</th>
                            <th>Amount</th>
                            <th>Control Number</th>
                            <th style={{width: '150px'}}>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.payments.map((d, i) => {
                                return (<tr key={i}>
                                    <td style={{textAlign: 'center', backgroundColor: 'white'}}>
                                        {i + 1}
                                    </td>
                                    <td>{d.payment_date}</td>
                                    <td>
                                        <span style={{color: 'darkcyan'}}>{d.bill_desc}</span>
                                    </td>
                                    <td>{d.payer_name}</td>
                                    <td>{d.amount}</td>
                                    <td>{d.control_number}</td>
                                    <td style={{fontSize: '8px'}}>
                                        {d.status !== 'Received' ?
                                            <button className={'btn error'} style={{width: '130px', textAlign: 'left'}}>
                                                <span className={'fa fa-times'}/>{d.status}
                                            </button> :
                                            <button className={'btn'} style={{
                                                width: '130px',
                                                textAlign: 'left',
                                                backgroundColor: '#484'
                                            }}>
                                                <span className={'fa fa-check'}/>{d.status}
                                            </button>}
                                    </td>
                                </tr>)
                            })
                        }

                        <tr>
                            <td className={'noHover'} colSpan={7} style={{textAlign: 'center'}}>
                                <button onClick={() => {
                                    this.setState({
                                        pageSize: this.state.pageSize - 20
                                    })
                                    this.fetchPaymentsByUrl(this.state.previous)
                                }} className={'btn default'}
                                        style={{visibility: this.state.previous !== null ? 'visible' : 'hidden'}}>Back
                                </button>
                                <b>{this.state.totalPages === 0 ? 0 : (this.state.pageSize) / 20}/{this.state.totalPages}</b>
                                <button onClick={() => {
                                    this.setState({
                                        pageSize: this.state.pageSize + 20
                                    })
                                    this.fetchPaymentsByUrl(this.state.next)
                                }} className={'btn default'}
                                        style={{visibility: this.state.next !== null ? 'visible' : 'hidden'}}>Next
                                </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                </div>
            </div>
        )
    }


}